import moment from 'moment';
import { CsvBuilder } from 'filefy';

export function handleExportCsv(columnsForExport, title) {
  const columnTitles = columnsForExport.map(
    (columnDef) => columnDef.title,
  );

  const epoch = Date.now();

  return new CsvBuilder(
    `${title}_${moment(new Date(epoch)).format(
      'DD-MM-YYYY_HH.mm',
    )}.csv`,
  )
    .setDelimeter(',')
    .setColumns(columnTitles)
    .addRows([])
    .exportFile();
}
